import type { F01SafetyAnswerRow } from "@care-by-ella/contracts";
import { f01SafetyLines, type SafetyTone } from "@/lib/f01-safety-lines";

// TES-1164 (Ö-383) — type 1 diabetes and MTC/MEN 2 on the patient overview,
// for both journeys: the answers F-01 owns, reused instead of asked again in
// F-02 ("Svaren ... återanvänds i F-02, admin och läkarens
// beslutsunderlag"). See f01-safety-lines.ts for the wording.
const TONE: Record<SafetyTone, string> = {
  stop: "bg-danger/10 text-danger",
  flag: "bg-warning/15 text-warning",
  none: "",
};

export function F01SafetyPanel({
  rows,
}: {
  rows: readonly F01SafetyAnswerRow[] | undefined;
}) {
  const lines = f01SafetyLines(rows);
  return (
    <section className="bg-surface border border-surfaceMuted rounded-md p-md">
      <h2 className="font-display text-lg mb-sm">Säkerhetsfrågor</h2>
      <dl className="flex flex-col gap-sm text-sm">
        {lines.map((l) => (
          <div key={l.topic}>
            <dt className="text-textSecondary">{l.topic}</dt>
            <dd>
              <span className="font-medium">{l.answer}</span>
              {l.source ? (
                <span className="text-xs text-textSecondary">
                  {" "}
                  ({l.source})
                </span>
              ) : null}
              {l.note ? (
                <span
                  className={`ml-xs inline-block rounded-sm px-xs text-xs ${TONE[l.tone]}`}
                >
                  {l.note}
                </span>
              ) : null}
              {l.question ? (
                <p className="text-xs text-textSecondary">{l.question}</p>
              ) : null}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
